import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitSelectedRepo } from '@/services/git/api';
import type { GitRepo } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitSelectedRepo(options?: { enabled?: boolean }): UseQueryResult<GitRepo | null, Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);
  const { enabled = true } = options ?? {};

  return useQuery({
    queryKey: ['gitSelectedRepo', orgId],
    queryFn: () => fetchGitSelectedRepo(orgId!),
    enabled: enabled && !!token && !!orgId,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
}
